/* eslint-disable @typescript-eslint/no-explicit-any */
import {useEffect, useState} from 'react';
import {Platform} from 'react-native';
import {
  defaultValues,
  showErrorValuesDefault,
  showErrorValuesSubmit,
} from '../../data/constants/Assurance/assuranceRetraite';

import {IError} from '../../data/types/interface/Assurance/assuranceRetraite';

export const useForm = (
  data: any,
  Validate: any,
  handleCancel: any,
  handleSave: any,
  listAgence?: any,
) => {
  const [values, setValues] = useState(data);
  const [dto, setDto] = useState({error: true, data});
  const [showErrors, setShowErrors] = useState(showErrorValuesDefault);
  const [errors, setErrors] = useState<IError>(defaultValues);

  const handleChange = (
    name: string,
    value: any,
    fired: boolean,
    remove?: boolean,
  ) => {
    let _value = value;
    if (name === 'cinContractant' || name === 'cinAssure') {
      if (_value === 'INVALID INPUT') {
        setValues({...values, [name]: []});
      } else {
        if (Platform.OS !== 'web') {
          if (Array.isArray(value)) {
            _value = value.map((item: any) => ({
              uri: item.uri,
              type: item.type,
              name: item.name,
            }));
          } else {
            _value = {
              uri: value.uri,
              type: value.type,
              name: value.fileName,
            };
          }
        }
        if (remove) {
          setValues({...values, [name]: _value});
        } else {
          const images = [...values[name]];
          images.push(_value);

          setValues({...values, [name]: images});
        }
      }
    } else {
      setValues({...values, [name]: _value});
    }
    setShowErrors({...showErrors, [name]: _value !== fired});
  };

  const noError = () => {
    let bNoError = true;
    Object.values(errors).forEach(element => {
      if (element !== '') {
        bNoError = false;
      }
    });
    return bNoError;
  };

  const handleSubmit = () => {
    setShowErrors(showErrorValuesSubmit);

    const validated = Validate(values, listAgence);

    setErrors(validated);
    const isThereError = noError();

    if (isThereError) {
      setDto({error: false, data: values});
    } else {
      setDto({error: true, data: {}});
    }
  };

  useEffect(() => {
    setErrors(Validate(values, listAgence));
  }, [values]);

  useEffect(() => {
    if (!dto.error) {
      handleSave();
    }
  }, [dto]);

  return {handleChange, handleSubmit, values, errors, showErrors, dto};
};
